import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Button, DialogHeader } from '@checkmarx/cx-ui';
import ConfirmationDialog from '../portal/dialogs/confirmationDialog';

@inject('translationsStore', 'addEditUserStore','usersStore') @observer
export default class AccessToUiDialog extends Component {

    state = {
        openAccessToUi: true,
    };

    handleAccessToUiDialog = e => {
       this.props.addEditUserStore.setAccessToUi(this.props.enableAccessToUi);

        this.props.addEditUserStore.updateAccessToUi(this.props.userId, this.props.enableAccessToUi)
            .then(() => {
                this.props.usersStore.getAllUsers();
                this.props.addEditUserStore.reset();
                this.onClose();
        });
    }

    onClose = e => {
        this.setState({
            openAccessToUi: false,
        });
        this.props.onClose();
    }

    render() {
        const confirmDialogContentFormated = <div>{this.props.dialogText}</div>;

        return (
            <div>
                <ConfirmationDialog
                    open={this.props.show}
                    onButtonClick={this.handleAccessToUiDialog}
                    onCancelClick={this.onClose}
                    buttonText={this.props.buttonText}
                    titleText={this.props.titleText}
                    contentText={this.props.dialogText}
                ></ConfirmationDialog>
            </div>);
    }
}
